import type { WithdrawalRequest } from 'api';

import { PrimaryButton } from '@atoms/buttons/PrimaryButton';
import { CheckCircleIcon } from '@atoms/Icon';

type Props = {
  withdrawalRequestData: WithdrawalRequest;
  onDialogClose: () => void;
};
export const WithdrawalSuccess = ({
  withdrawalRequestData,
  onDialogClose
}: Props) => {
  return (
    <div>
      <div className="flex flex-col items-center gap-6">
        <CheckCircleIcon className="w-8 fill-content-brand" />
        <div className="text-center text-lg font-semibold">
          Withdraw funds request has been sent
        </div>
        <div className="text-lg font-semibold">
          Reference: {withdrawalRequestData.reference}
        </div>
        <div className="text-center text-sm font-semibold">
          The request will be sent for processing after review.
        </div>
      </div>
      <PrimaryButton
        className="mt-10 w-full"
        onClick={() => {
          onDialogClose();
        }}
      >
        Done
      </PrimaryButton>
    </div>
  );
};
